import plugin from '@core/plugins/lib';

const ELEMENT_SELECTOR = '[data-input-qty]';
const PLUGIN_NAME = 'InputQty';

$(() => {
	$(ELEMENT_SELECTOR).each(function() {
		const element = this;
		System.import(
			/* webpackChunkName: "plugin--input-qty" */ './input-qty'
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./client/src/core/components/forms/input-qty/index.js